/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Self_Organize_No_CandidatesInputs */



/**
* | output |
* | --- |
* | "No other eligible players are registered right now." |
*
* @param {Self_Organize_No_CandidatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_no_candidates = /** @type {((inputs?: Self_Organize_No_CandidatesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_No_CandidatesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun autre joueur éligible n'est inscrit pour le moment.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay otros jugadores elegibles inscritos en este momento.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum outro jogador elegível está inscrito no momento.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun altro giocatore eleggibile è iscritto al momento.")
	return /** @type {LocalizedString} */ ("No other eligible players are registered right now.")
});